import styled from "styled-components";
import { CSSVars } from "@/styles/styles.config";

export const StyledSection = styled.section`
  background: linear-gradient(
    90deg,
    rgba(91, 91, 255, 0.06) 0%,
    rgba(166, 108, 217, 0.05) 50%,
    rgba(245, 138, 138, 0.06) 100%
  );
  border-top: 1px solid ${CSSVars.gray100};
  border-bottom: 1px solid ${CSSVars.gray100};
  padding: 48px 20px;

  @media screen and (min-width: ${CSSVars.breakpointMD}) {
    padding: 64px 30px;
  }
  @media screen and (min-width: ${CSSVars.breakpointLG}) {
    padding: 72px 40px;
  }

  .strip {
    list-style: none;
    margin: 0 auto;
    padding: 0;
    max-width: 1100px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 36px 48px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      justify-content: space-around;
      gap: 0 24px;
    }
  }

  .stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex: 1 1 calc(50% - 24px);
    min-width: 140px;
    padding: 4px 8px;
    gap: 12px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      flex: 1 1 0;
      padding: 8px 16px;
      gap: 14px;
    }

    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      padding: 12px 24px;
    }
  }

  .value {
    font-family: ${CSSVars.primaryFont};
    font-weight: 700;
    font-size: 28px;
    line-height: 1;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, ${CSSVars.blue500} 0%, ${CSSVars.purple500} 50%, ${CSSVars.pink300} 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 36px;
    }
    @media screen and (min-width: ${CSSVars.breakpointLG}) {
      font-size: 42px;
    }
  }

  .label {
    font-family: ${CSSVars.secondaryFont};
    font-size: 13px;
    font-weight: 500;
    color: #4b5563;
    letter-spacing: 0.2px;

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      font-size: 14px;
    }
  }
`;
